import type { Deferred } from '@patsnap/tahiti-core';

export interface PageInitService {
    initDeferred: Deferred<void>
    pullPageInitData(): Promise<void>;
}

export const PageInitService = Symbol('PageInitService');
